import routes from './routes';

export * from './Pages/index';
export default routes;